import { AxiosResponse } from "axios";
import { api } from "./base/api";
import { Result } from "../models/common/resultResponse";
import { SaveSupplierEvaluationRequest } from "../models/request/evaluationSupplierRequest";
import { IEvaluationCompanyBuyerApi } from "./base/evaluationCompanyBuyerApi";
import {
	EvaluationCompanyBuyerResponse,
	EvaluationSupplierPartsResponse,
	SaveSupplierEvaluationResult,
} from "../models/response/evaluationSupplierResponse";

const baseRoute: string = "EvaluationCompanyBuyer";
export class EvaluationCompanyBuyerApi extends IEvaluationCompanyBuyerApi {
	saveSupplierEvaluation(
		request: SaveSupplierEvaluationRequest,
	): Promise<AxiosResponse<Result<SaveSupplierEvaluationResult>>> {
		return api.post(`${baseRoute}/savesupplierevaluation`, request);
	}
	getPartsToEvaluateSupplier(
		guidProcurement: string,
		guidSupplier: string | null,
	): Promise<AxiosResponse<Result<EvaluationSupplierPartsResponse[]>>> {
		return api.get(`${baseRoute}/getpartstoevaluatesupplier`, {
			params: { guidProcurement, guidSupplier },
		});
	}
	getSupplierEvaluationByGuid(
		guidEvaluationCompanyBuyer: string | null,
	): Promise<AxiosResponse<Result<EvaluationCompanyBuyerResponse>>> {
		return api.get(`${baseRoute}/getsupplierevaluationbyguid`, {
			params: { guidEvaluationCompanyBuyer },
		});
	}
	saveEvaluationPublic(
		saveEvaluationRequest: SaveSupplierEvaluationRequest,
	): Promise<AxiosResponse<Result<SaveSupplierEvaluationResult>>> {
		return api.post(`${baseRoute}/saveevaluation_public`, saveEvaluationRequest);
	}
}
